import { useInfiniteQuery } from '@tanstack/react-query';

import { tariffsInfiniteQueryOptions } from '../data-provider/search-tariffs';
import type { TariffsSearchParams } from '../models';

export const useTariffs = (filters: TariffsSearchParams) => {
  return useInfiniteQuery(tariffsInfiniteQueryOptions(filters));
};
